module.exports = __webpack_public_path__ + "static/media/departmetEdit.0d428dbf.svg";